<div class="container-registration">
  <!-- LOGO del progetto -->
  <div class="logo-registration">
    <a href="https://workinc.vtserver.eu/" target="_blank">
      <img src="img/logo_white.png" [attr.alt]="'auth.logo-alt' | translate" />
    </a>
  </div>

  <div class="registration-box">
    <h2>{{ 'auth.registration.title' | translate }}</h2>

    <form #registerForm="ngForm" (ngSubmit)="register(registerForm)">

      <app-alert-message> </app-alert-message>

      <label for="email">{{ 'auth.fields.email' | translate }}</label>
      <input type="email" id="email" name="email" [(ngModel)]="email" placeholder="{{ 'auth.placeholders.email' | translate }}" required />

      <label for="password">{{ 'auth.fields.password' | translate }}</label>
      <div class="password-container">
        @if(!showPassword){    
          <input type="password" id="password" name="password" [(ngModel)]="password" 
          placeholder="{{ 'auth.placeholders.password' | translate }}" required />
        }
        @else {
          <input type="text" id="password" name="password" [(ngModel)]="password" 
          placeholder="{{ 'auth.placeholders.password' | translate }}" required />
        }
        <app-password-validation [password]="password" (validityChange)="onPasswordValidityChange($event)" class="password-popup"></app-password-validation>
      </div>

      <label for="confirmPassword">{{ 'auth.fields.confirm-password' | translate }}</label>
      @if(!showPassword){   
        <input type="password" id="confirmPassword" name="confirmPassword" [(ngModel)]="confirmPassword" 
        placeholder="{{ 'auth.placeholders.confirm-password' | translate }}" required />
      }
      @else {
        <input type="text" id="confirmPassword" name="confirmPassword" [(ngModel)]="confirmPassword" 
        placeholder="{{ 'auth.placeholders.confirm-password' | translate }}" required />
      }
      
      <div class="show-password">
        <mat-checkbox (change)="showPassword=!showPassword"></mat-checkbox><a>{{ 'auth.show-password' | translate }}</a>
      </div>
      
      <label for="sector">{{ 'auth.registration.sector' | translate }}</label>
      <mat-form-field class="sector-field" appearance="outline">
        <mat-label>{{ (loadingSectors ? 'auth.registration.loading-sectors' : 'auth.registration.select-sector') | translate }}</mat-label>
        <mat-select id="sector" name="sector" [(ngModel)]="sector" required [disabled]="loadingSectors">
          <mat-option *ngFor="let s of sectors" [value]="s">{{ s.name }}</mat-option>
        </mat-select>
      </mat-form-field>

      <button type="submit" [disabled]="loadingRegister" >{{ 'auth.registration.submit' | translate }}</button>

      <div class="registration-links">
        <a routerLink="/login" class="link-back">
          <mat-icon>arrow_back</mat-icon>
          <span>{{ 'auth.back-to-login' | translate }}</span>
        </a>
      </div>

    </form>
  </div>
</div>
